import { render, staticRenderFns } from "./ExpressDetail.vue?vue&type=template&id=203b25a2&"
import script from "./ExpressDetail.vue?vue&type=script&lang=js&"
export * from "./ExpressDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports